export default function isLorebookEntriesNeedAlert(numRejectedEntries: number, numNeedsReviewEntries: number, numNeedsFixEntries = 0) {
  return numRejectedEntries > 0 || numNeedsReviewEntries > 0 || numNeedsFixEntries > 0;
}
